import { getTranslate } from '@nx/translations'

import {
  StyledContainer,
  StyledInfoIcon,
  StyledMessage,
  StyledTitle,
} from './OutbidMessage.styles'
import translate from './OutbidMessage.translate.json'

const { text } = getTranslate(translate)

export const OutbidMessage = () => {
  return (
    <StyledContainer>
      <StyledTitle $level={6} as="div">
        <StyledInfoIcon />
        {text('title')}
      </StyledTitle>
      <StyledMessage>{text('message')}</StyledMessage>
    </StyledContainer>
  )
}
